import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filter',
	standalone: true,
})
export class FilterPipe implements PipeTransform {
	transform<T extends Record<string, unknown>, U>(
		arr: T[] | null,
		field: string,
		value: U,
		condition?: (item: T, value: U) => boolean
	): T[] {
		if (arr === null) {
			return [];
		}
		if (condition) {
			return arr.filter((item) => {
				return condition(item, value);
			});
		}
		return arr.filter((item) => {
			return item[field] === value;
		});
	}
}
